import TrustPilotTwoLinesWidget from 'components/TrustPilotTwoLinesWidget';
import LoginForm from 'components/authentication/LoginForm';
import { BaseRegisterForm } from 'components/authentication/RegisterForm';
import EnterLayout from 'components/enter2026/EnterLayout';
import MainLayout from 'components/layout/MainLayout';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { getCheckout2026Value } from 'utils/ab-test/abTests';
import TealCircleTicket from '../../components/svg/TealCircleTicket.svg';
import styles from './5.module.css';
import { useEnterFlowPreconditionCheck } from 'hooks/enter/useEnterFlowPreconditionCheck';

interface EnterNowStep5Props {}

const EnterNowStep5 = observer((_props: EnterNowStep5Props) => {
  const router = useRouter();
  const userStore = useUserStore();
  const [mode, setMode] = useState<'SIGN_UP' | 'SIGN_IN'>('SIGN_UP');

  useEffect(() => {
    if (userStore.currentUser?.id) {
      router.push('/checkout');
    }
  }, [userStore.currentUser?.id]);

  useEffect(() => {
    // Check for Checkout2026 variant and redirect if V1 or V2
    const checkoutVariant = getCheckout2026Value();
    if (checkoutVariant && checkoutVariant !== 'CONTROL') {
      router.push('/checkout');
    }
  }, [router]);

  useEnterFlowPreconditionCheck();

  return (
    <MainLayout limitItemWidths>
      <EnterLayout
        sidePanel={
          <div className={styles.sideBar}>
            <p className="aboutUsTypographyHeaderLarge">
              We’ll contact you by email if you win
            </p>
            <img
              src="https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/enter/Envelope.png"
              alt=""
            />
          </div>
        }
        sidePanelBackground={'TEAL'}
        stepIcon={<TealCircleTicket />}
        stepName={mode === 'SIGN_UP' ? 'Sign up' : 'Sign in'}
        stepIndex={4}
      >
        {mode === 'SIGN_IN' ? (
          <LoginForm
            elementBeforeLoginButtons={
              <p className={styles.signInText}>
                Don't have an account yet?
                <br />
                <a
                  onClick={() =>
                    setMode((x) => (x === 'SIGN_IN' ? 'SIGN_UP' : 'SIGN_IN'))
                  }
                >
                  Create an account
                </a>
              </p>
            }
            noStyleOnSignInWithEmailPrompt
            showRequiredFieldIndicators
            submitButtonTitle="Continue"
            socialButtonStyle="CIRCLE_ON_MOBILE"
            completionHandler={function (): void {
              router.push('/checkout');
            }}
            appleRedirectPath="/register"
          />
        ) : (
          <BaseRegisterForm
            elementAfterRegisterButtons={
              <p className={styles.registerText}>
                Sign up or{' '}
                <a
                  onClick={() =>
                    setMode((x) => (x === 'SIGN_IN' ? 'SIGN_UP' : 'SIGN_IN'))
                  }
                >
                  log in
                </a>{' '}
                to complete your purchase, redeem prizes and manage your plan.
              </p>
            }
            socialButtonStyle="CIRCLE_ON_MOBILE"
            excludeFormFieldsList={['DATE_OF_BIRTH', 'PHONE_NUMBER']}
            showRequiredFieldIndicators
            submitButtonTitle="Continue"
            completionHandler={async () => {
              router.push('/checkout');
            }}
            appleRedirectPath="/register"
          />
        )}
        <TrustPilotTwoLinesWidget />
      </EnterLayout>
    </MainLayout>
  );
});

export default EnterNowStep5;

export const getServerSideProps: GetServerSideProps<
  EnterNowStep5Props
> = async (_ctx) => {
  return {
    props: {},
  };
};
